import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { X } from "lucide-react";
import { indianStatesOnly } from "../../data/stateData";

const LocationInfoClient = ({
  formData,
  setFormData,
  showCreateGst,
  isGstId,
  setShowCreateGst,
  errors,
  isLoading,
  handelUpdate,
}) => {
  const onChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="bg-white w-4/5 md:w-3/5 p-2 rounded-lg z-50 max-h-[90vh] overflow-auto"
    >
      <div className="flex flex-row items-center justify-between border-b border-b-gray-200 pb-2">
        <div className="text-lg font-semibold text-gray-900">
          Office Locations {isGstId ? "Edit" : "New"}
        </div>
        <button
          type="button"
          onClick={() => {
            setShowCreateGst(false);
            setFormData({
              id: null,
              address: "",
              city: "",
              state: "",
              pincode: "",
              locationType: "",
            });
          }}
          className="bg-red-50 p-1rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
        >
          <X />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-start">
        <FormField
          label="City"
          value={formData.city}
          onChange={(v) => onChange("city", v)}
          error={errors?.city}
          required
        />

        <FormField
          label="State"
          type="dropdown"
          value={formData.state}
          options={indianStatesOnly}
          onChange={(v) => onChange("state", v)}
          error={errors?.state}
          required
        />

        <FormField
          label="Pincode"
          value={formData.pincode}
          onChange={(v) =>
            onChange("pincode", v.replace(/\D/g, "").slice(0, 6))
          }
          error={errors?.pincode}
          required
        />

        <FormField
          label="Location Type"
          type="dropdown"
          options={[
            " HEAD_OFFICE",
            "BRANCH_OFFICE",
            "REGISTERED_OFFICE",
            "CORPORATE_OFFICE",
            "SALES_OFFICE",
            "OTHER",
          ]}
          value={formData.locationType}
          onChange={(v) => onChange("locationType", v)}
          error={errors?.locationType}
          required
        />
        <div className="md:col-span-2">
          <FormField
            label="Address"
            type="description"
            value={formData.address}
            onChange={(v) => onChange("address", v)}
            error={errors?.address}
            required
          />
        </div>
      </div>

      <div className="flex flex-row items-center justify-end gap-2">
        <button
          type="button"
          onClick={() => {
            setShowCreateGst(false);
            setFormData({
              id: null,
              address: "",
              city: "",
              state: "",
              pincode: "",
              locationType: "",
            });
          }}
          className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
        >
          Cancel
        </button>
        {isLoading ? (
          <Button label={<Spinner size={"sm"} />} />
        ) : (
          <Button
            label={isGstId ? "Update" : "Save"}
            type="button"
            onClick={(e) => handelUpdate(e)}
            className="m-2"
          />
        )}
      </div>
    </div>
  );
};

export default LocationInfoClient;
